import { Session } from 'talkjs/types/talk.types';
import { ShowroundsAnalyticsContext } from '@bridebook/web/lib/showrounds/types/types';

export type InboxContext = {
  session?: Session;
  conversationId?: string;
  inboxView?: InboxView;
  setConversationId: (conversationId: string | undefined) => void;
  isShowroundModalLoading?: boolean;
  openShowroundModal?: (analyticsContext: ShowroundsAnalyticsContext) => void;
};

/**
 * Note: Enum values are used in the URL query param `view`
 */
export enum InboxView {
  Suppliers = 'suppliers',
  MessageCenter = 'notifications',
  Archived = 'archived',
  Guests = 'guests',
}

export const isInboxView = (view: any): view is InboxView =>
  Object.values(InboxView).includes(view);
